// extracted by mini-css-extract-plugin
export default {"commentSubmit":"NewComment_commentSubmit__iFHCy"};